

// store/slices/stockSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import stockApi from 'api/stockApi';

export const fetchStocks = createAsyncThunk(
  'stock/fetchAll',
  async ({ page = 1, pageSize = 10, search = '' }, { rejectWithValue }) => {
    try {
      const res = await stockApi.getAll(page, pageSize, search);
      return res;
    } catch (e) {
      return rejectWithValue(e.response?.data?.detail || 'Failed to load stock levels');
    }
  }
);

const stockSlice = createSlice({
  name: 'stock',
  initialState: {
    stocks: [],
    pagination: { count: 0, page_size: 10, next: null, previous: null },
    isLoading: false,
    error: null,
  },
  reducers: {
    clearError: (s) => { s.error = null; },
  },
  extraReducers: (b) => {
    b.addCase(fetchStocks.pending, (s) => { s.isLoading = true; })
      .addCase(fetchStocks.fulfilled, (s, a) => {
        s.isLoading = false;
        s.stocks = a.payload.data || [];
        s.pagination = a.payload.pagination || { count: 0, page_size: 10 };
      })
      .addCase(fetchStocks.rejected, (s, a) => {
        s.isLoading = false;
        s.error = a.payload;
      });
  },
});

export const { clearError } = stockSlice.actions;
export default stockSlice.reducer;